import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "card__head d-flex align-items-center" }
const _hoisted_2 = { class: "d-flex align-items-center text-uppercase mb-0" }
const _hoisted_3 = { class: "bt-icon bt-icon--m" }
const _hoisted_4 = { class: "ml-2" }
const _hoisted_5 = { class: "ml-3" }
const _hoisted_6 = { class: "d-flex align-items-center ml-auto" }
const _hoisted_7 = {
  key: 0,
  class: "d-inline-flex align-items-center fs-18 mb-0 mr-3"
}
const _hoisted_8 = { class: "bt-icon bt-icon--s ml-2 text-warning" }
const _hoisted_9 = { class: "btn-stripped text-danger" }
const _hoisted_10 = {
  key: 0,
  class: "list-blocks"
}
const _hoisted_11 = { class: "room-object__head" }
const _hoisted_12 = { class: "room-object__icon bt-icon bt-icon--s" }
const _hoisted_13 = { style: {"text-transform":"capitalize"} }
const _hoisted_14 = { class: "room-object__quick-actions" }
const _hoisted_15 = {
  key: 0,
  class: "room-object room-object--thermo-settings align-content-center"
}
const _hoisted_16 = {
  key: 1,
  class: "list-blocks"
}
const _hoisted_17 = { class: "room-object__head" }
const _hoisted_18 = {
  key: 0,
  class: "room-object__icon bt-icon bt-icon--s"
}
const _hoisted_19 = {
  key: 2,
  class: "list-blocks"
}
const _hoisted_20 = { class: "list-unstyled d-flex align-items-center mb-0" }
const _hoisted_21 = { class: "room-object" }
const _hoisted_22 = { class: "room-object__head" }
const _hoisted_23 = { class: "room-object__icon bt-icon bt-icon--s" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")
  const _component_DeviceCarousel = _resolveComponent("DeviceCarousel")
  const _component_Card = _resolveComponent("Card")
  const _component_DialogCommandIcon = _resolveComponent("DialogCommandIcon")
  const _component_DialogObjectSettings = _resolveComponent("DialogObjectSettings")
  const _component_DialogThermoObjectSettings = _resolveComponent("DialogThermoObjectSettings")
  const _component_DialogConfirmDelete = _resolveComponent("DialogConfirmDelete")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Card, _mergeProps(_ctx.$attrs, { class: "card--primary" }), {
      content: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("h4", _hoisted_2, [
            _createVNode("span", _hoisted_3, [
              _createVNode(_component_InlineSvgScoped, {
                src: require(`@/assets/images/icons/${_ctx.getObjectIcon(_ctx.roomObject)}.svg`),
                "aria-label": "icon-blueprint"
              }, null, 8, ["src"])
            ]),
            _createVNode("span", _hoisted_4, _toDisplayString(_ctx.roomObject.name), 1)
          ]),
          _createVNode("span", _hoisted_5, _toDisplayString(_ctx.getObjectDescLabel(_ctx.roomObject)), 1),
          _createVNode("div", _hoisted_6, [
            (_ctx.roomObject.hasConfigurationToEnd)
              ? (_openBlock(), _createBlock("p", _hoisted_7, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t("AppResource.ConfigurationToEnd")), 1),
                  _createVNode("span", _hoisted_8, [
                    _createVNode(_component_InlineSvgScoped, {
                      src: require('@/assets/images/icons/icon-alert-hight-full.svg'),
                      "aria-label": "icon-alert-hight-full"
                    }, null, 8, ["src"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.hideConfig)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  class: "apartment__action p-button-rounded ml-auto",
                  label: _ctx.$t('AppResource.Configure'),
                  onClick: _ctx.goToAssignObject
                }, null, 8, ["label", "onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_ElDropdown, {
              trigger: "click",
              placement: "bottom-end",
              "popper-class": "el-dropdown__popper el-dropdown--context"
            }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_ElDropdownMenu, { style: {"width":"300px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ElDropdownItem, { onClick: _ctx.toggleDeleteObjectConfirm }, {
                      default: _withCtx(() => [
                        _createVNode("button", _hoisted_9, _toDisplayString(_ctx.$t("AppResource.DeleteObject")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_Button, { class: "p-button p-button-text p-button-secondary py-0 ml-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InlineSvgScoped, {
                      src: require('@/assets/images/icons/icon-ellipsis-v.svg'),
                      "aria-label": "icon-ellipsis-v"
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, !_ctx.disableActions && _ctx.roomObject.type != _ctx.RoomObjectType.AlarmSensor]
                ])
              ]),
              _: 1
            })
          ])
        ]),
        (_ctx.roomObjectDevices.length > 0)
          ? (_openBlock(), _createBlock("ul", _hoisted_10, [
              _createVNode("li", null, [
                _createVNode(_component_DeviceCarousel, {
                  itemsNumber: _ctx.roomObjectDevices.length + (_ctx.isThermoRoomObject ? 1 : 0)
                }, {
                  carouselItems: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.roomObjectDevices, (device) => {
                      return (_openBlock(), _createBlock("div", {
                        key: device.id,
                        class: "room-object"
                      }, [
                        _createVNode("div", _hoisted_11, [
                          _createVNode("span", _hoisted_12, [
                            _createVNode(_component_InlineSvgScoped, {
                              src: require(`@/assets/images/icons/${_ctx.getDeviceIcon(device)}.svg`)
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("span", null, _toDisplayString(device.model) + " - ID " + _toDisplayString(device.id), 1)
                        ]),
                        _createVNode("span", _hoisted_13, _toDisplayString(_ctx.getConfiguredChannelsOrModulesText(device)), 1),
                        _createVNode("div", _hoisted_14, [
                          (device.defaultSettings)
                            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                (_ctx.hasDeviceSettingsButton(device))
                                  ? (_openBlock(), _createBlock(_component_Button, {
                                      key: 0,
                                      onClick: ($event: any) => (_ctx.toggleDialogObjectSettings(device)),
                                      label: _ctx.$t('AppResource.Settings'),
                                      class: "p-button-text"
                                    }, null, 8, ["onClick", "label"]))
                                  : _createCommentVNode("", true),
                                (_ctx.hasDeviceCommandIconButton(device))
                                  ? (_openBlock(), _createBlock(_component_Button, {
                                      key: 1,
                                      onClick: ($event: any) => (_ctx.toggleDialogCommandIcon(device)),
                                      label: _ctx.$t('AppResource.CommandIcon'),
                                      class: "p-button-text"
                                    }, null, 8, ["onClick", "label"]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128)),
                    (_ctx.isThermoRoomObject)
                      ? (_openBlock(), _createBlock("div", _hoisted_15, [
                          _createVNode(_component_Button, {
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleDialogThermoObjectSettings())),
                            label: _ctx.$t('AppResource.Settings'),
                            class: "p-button-text"
                          }, null, 8, ["label"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["itemsNumber"])
              ])
            ]))
          : _createCommentVNode("", true),
        (
                    _ctx.roomObject.extDevices &&
                    _ctx.roomObject.extDevices.length > 0 &&
                    _ctx.roomObject.type != _ctx.RoomObjectType.AlarmSensor
                )
          ? (_openBlock(), _createBlock("ul", _hoisted_16, [
              _createVNode("li", null, [
                _createVNode(_component_DeviceCarousel, {
                  itemsNumber: _ctx.roomObject.extDevices.length
                }, {
                  carouselItems: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.roomObject.extDevices, (extDevice, i) => {
                      return (_openBlock(), _createBlock("div", {
                        key: i,
                        class: "room-object"
                      }, [
                        _createVNode("div", _hoisted_17, [
                          (extDevice.componentType !== undefined)
                            ? (_openBlock(), _createBlock("span", _hoisted_18, [
                                _createVNode(_component_InlineSvgScoped, {
                                  src: require(`@/assets/images/icons/${_ctx.getExtDeviceIconFromType(extDevice.componentType)}.svg`)
                                }, null, 8, ["src"])
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode("span", null, _toDisplayString(_ctx.getExtDeviceIdentifier(extDevice)), 1)
                        ]),
                        _createVNode("span", null, _toDisplayString(_ctx.getExtDeviceActiveLink(extDevice)), 1)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["itemsNumber"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.roomObject.type == _ctx.RoomObjectType.Thermostat99zones)
          ? (_openBlock(), _createBlock("ul", _hoisted_19, [
              _createVNode("li", null, [
                _createVNode("ul", _hoisted_20, [
                  _createVNode("li", _hoisted_21, [
                    _createVNode("div", _hoisted_22, [
                      _createVNode("span", _hoisted_23, [
                        _createVNode(_component_InlineSvgScoped, {
                          class: "text-primary",
                          src: require(`@/assets/images/icons/icon-room.svg`)
                        }, null, 8, ["src"])
                      ]),
                      _createVNode("span", null, _toDisplayString(_ctx.$t("AppResource.ZoneUpper")), 1)
                    ]),
                    _createVNode("span", null, _toDisplayString(_ctx.getThermo99Description(_ctx.roomObject)), 1)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16),
    (_ctx.selectedDefaultSettings)
      ? (_openBlock(), _createBlock(_component_DialogCommandIcon, {
          key: 0,
          "is-visible": _ctx.isVisibleDialogCommandIcon,
          defaultSettings: _ctx.selectedDefaultSettings,
          onHideDialog: _ctx.toggleDialogCommandIcon
        }, null, 8, ["is-visible", "defaultSettings", "onHideDialog"]))
      : _createCommentVNode("", true),
    (_ctx.selectedDefaultSettings)
      ? (_openBlock(), _createBlock(_component_DialogObjectSettings, {
          key: 1,
          "is-visible": _ctx.isVisibleDialogObjectSettings,
          defaultSettings: _ctx.selectedDefaultSettings,
          onHideDialog: _ctx.toggleDialogObjectSettings
        }, null, 8, ["is-visible", "defaultSettings", "onHideDialog"]))
      : _createCommentVNode("", true),
    _createVNode(_component_DialogThermoObjectSettings, {
      "is-visible": _ctx.isVisibleDialogThermoObjectSettings,
      onHideDialog: _ctx.toggleDialogThermoObjectSettings,
      "plant-id": _ctx.$route.params.plantId,
      "room-id": _ctx.$route.params.roomId,
      "room-object-id": _ctx.roomObject.id
    }, null, 8, ["is-visible", "onHideDialog", "plant-id", "room-id", "room-object-id"]),
    _createVNode(_component_DialogConfirmDelete, {
      "is-visible": _ctx.isVisibleDeleteObjectConfirm,
      title: _ctx.$t('AppResource.DeleteObject'),
      message: _ctx.$t('AppResource.DeleteObjectQuestion'),
      onHideDialog: _ctx.toggleDeleteObjectConfirm,
      onConfirm: _ctx.handleDeleteObject
    }, null, 8, ["is-visible", "title", "message", "onHideDialog", "onConfirm"])
  ], 64))
}